import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import AdminService from '../../../services/admin';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import {Link} from "react-router-dom";
import {grey400} from 'material-ui/styles/colors';
import {ADMIN} from '../../../services/admin';
import {fetchApp} from '../../../store/apps/actions';
import {FlatButton, Dialog} from "material-ui";
import style from '../../../styles/styles';
import styles from './TypePage.css';
import IconButton from 'material-ui/IconButton';
import TypeFull from "../../../components/type/TypeFull/TypeFull";
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import {fetchType, deleteType, postTypePicture, deleteTypePicture} from "../../../store/types/actions";
import {EDIT_TYPE_PAGE, SETTING_PAGE} from "../../../constants/routes";
import withTranslation from '../../../hoc/withTranslation';

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={grey400}/>
    </IconButton>
);

export class TypePage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        type: PropTypes.object
    };

    state = {
        typeToRemove: null,
        openRemoveType: false,
        openRemoveTypePicture: false
    };

    static defaultProps = {};

    componentWillMount() {
        this.fetchApplication();
        this.fetchType();
    }

    // Fetch

    fetchType(appId = null, typeId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const type = typeId || this.props.match.params.typeId;

            if (app && type) {
                this.props.fetchType(app, type)
            }
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    handleDeleteType = (type) => {
        this.setState({
            openRemoveType: true,
            typeToRemove: this.props.type
        });
    };

    handleCloseType = () => {
        this.setState({
            openRemoveType: false,
            typeToRemove: null
        });
    };

    deleteTypePicture = () => {
        this.props.deleteSubjectPicture(this.props.app.id, this.props.type.id);
        this.setState({
            openRemoveTypePicture: false
        });
    };

    deleteType = () => {
        this.props.deleteType(this.props.app.id, this.props.type.id);
        this.props.history.push(SETTING_PAGE.replace(':appId', this.props.app.id));
    };

    renderDeleteTypeDialog(type) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseType}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteType}
            />
        ];

        return (
            <Dialog actions={actions}
                    modal={this.props.sending}
                    open={this.state.openRemoveType}
                    onRequestClose={this.handleCloseType}>
                {this.props.sending && <Loading paper={false}/>}
                {!this.props.sending &&
                <p>
                    Do you really want to remove the type "{type.name}" ?
                </p>
                }
            </Dialog>
        );
    }

    handleDeleteTypePicture = () => {
        this.setState({
            openRemoveTypePicture: true
        });
    };

    handleCloseTypePicture = () => {
        this.setState({
            openRemoveTypePicture: false
        });
    };

    renderDeleteTypePictureDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseTypePicture}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteTypePicture}
            />
        ];

        return (
            <Dialog actions={actions}
                    modal={this.props.sending}
                    open={this.state.openRemoveTypePicture}
                    onRequestClose={this.handleCloseType}>
                {this.props.sending && <Loading paper={false}/>}
                {!this.props.sending &&
                <p>
                    Do you really want to remove the picture ?
                </p>
                }
            </Dialog>
        );
    }
    // Render

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.type) {
            return <Loading paper={false}/>;
        } else {
            let menu;
            if (AdminService.isAuthorized(ADMIN, this.props.user)) {
                menu = (
                    <IconMenu
                        style={styles.buttons}
                        listStyle={style.list}
                        iconButtonElement={iconButtonElement}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}>
                        <Link to={EDIT_TYPE_PAGE.replace(':appId', this.props.app.id).replace(':typeId', this.props.type.id)} >
                            <MenuItem>
                                {this.props.t('generic.edit')}
                            </MenuItem>
                        </Link>
                        <MenuItem onClick={this.handleDeleteType}>
                            {this.props.t('generic.remove')}
                        </MenuItem>
                        {this.props.type.picture &&
                        <MenuItem onClick={this.handleDeleteTypePicture}>
                            {this.props.t('generic.remove_picture')}
                        </MenuItem>}
                    </IconMenu>
                );
            } else {
                menu = null;
            }
            return (
                <div>
                    {this.state.openRemoveType && this.renderDeleteTypeDialog(this.state.typeToRemove)}
                    {this.state.openRemoveTypePicture && this.renderDeleteTypePictureDialog()}
                    <h3 style={style.navigation}>Type / Detail - {this.props.app.name}</h3>
                    {menu}
                    <TypeFull app={this.props.app} type={this.props.type} postPicture={this.props.postTypePicture} deletePicture={this.props.deleteSubjectPicture}/>
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apps.pending || state.types.pending,
        error: state.apps.error,
        type: state.types.currentType,
        app: state.apps.currentApplication,
        sending: state.types.sending,
        user: state.auth.content
    };
}

export default connect(mapStateToProps, {
    postTypePicture,
    deleteTypePicture,
    deleteType,
    fetchApp,
    fetchType
})(withTranslation(TypePage));



// WEBPACK FOOTER //
// src/containers/types/TypePage/TypePage.js